<template>
	<div class="ct-card">
		<div  @click="setOverOnCard" class="ct-card-content ct-clickable" :class="{'ct-card-text-over': imageOver}">
			<transition name="bounce">
				<div class="ct-card-image ct-clickable" v-show="!imageOver">
					<img :src="getImgUrl(menu.image, menu.directory)">
				</div>
			</transition>
			<div class="ct-card-text" >
				<div class="ct-card-text-title ct-policy-enter">
					{{ menu.title }}
				</div>
				<div class="ct-card-text-content ct-justify-text" v-show="textOver">
					<ul>
						<li v-for="detail in menu.contents">
							<i class="material-icons ct-puce">keyboard_arrow_right</i>
							{{ detail }}
						</li>
					</ul>
				</div>
			</div>
		</div>
		<router-link class="ct-card-footer ct-policy-enter" :to="menu.route">
			<span class="ct-card-footer-item ct-clickable">Visiter</span>
		</router-link>
	</div>
</template>

<script>

	import {getDirectoryForDevice} from '../actions/generalData';

	export default {
		name: 'CtCard',
		props: {
			menu: {
				type: Object,
				required: true,
			}
		},
		data() {
			return {
				imageOver: false,
				textOver: false,
				textTime: 500,
				defaultOverTime: 500,
				deviceDirectory: '',

			}
		},
		methods: {
			getImgUrl(name, directory) {
				return require('../assets/' + this.deviceDirectory + directory + name)
			},
			setOverOnText: function () {
				this.textOver = !this.textOver;
			},
			setOverOnImage: function () {
				this.imageOver = !this.imageOver;
			},
			setOverOnCard() {
				if (this.imageOver) {
					this.setOverOnText();
					setTimeout(this.setOverOnImage, 100)
				}
				else {
					this.setOverOnImage(),
						setTimeout(this.setOverOnText, this.textTime)
				}
				this.textTime === this.defaultOverTime ? this.textTime = 0 : this.textTime = this.defaultOverTime;
			},
		},
		mounted: function() {
			this.deviceDirectory = getDirectoryForDevice(screen.width)
		}
	}
</script>

<style scoped>

	.ct-card {
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.6);
		transition: 0.3s;
		border-radius: 3px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		background-color: white;
		height: 100%;
	}

	.ct-card:hover {
		box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.6);
	}

	.ct-card-image {
		flex: 3;
	}

	.ct-card-image img {
		width: 100%;
	}

	.ct-card-text {
		padding: 1em;
		/*flex: 2;*/
	}

	.ct-card-text-over {
		background-color: #4A4A4A;
		color: #ffffff;
		opacity: 0.95;
	}

	.ct-card-text-title {
		display: flex;
		justify-content: flex-start;
		text-transform: uppercase;
		font-weight: 600;
	}

	.ct-card-footer {
		display: flex;
		justify-content: center;
		text-transform: uppercase;
		color: #B0E900;
		background-color: #4A4A4A;
		padding: 1em;
		line-height: 1.5em;
	}

	.ct-card-footer-item:hover {
		color: #CCFF33;
	}

	.ct-card-content {
		height: 100%;
		transition: background-color 2s;

	}

	/* animation image */
	.bounce-enter-active {
		animation: bounce-in .5s;
	}
	.bounce-leave-active {
		animation: bounce-in .5s reverse;
	}
	@keyframes bounce-in {
		0% {
			transform: scale(0);
		}
		50% {
			transform: scale(1.5);
		}
		100% {
			transform: scale(1);
		}
	}


</style>



// WEBPACK FOOTER //
// src/components/CtCard.vue